<template>
    <section>
        <header>
            All Map Objects
            <img
                :src="areAllObjectsHidden ? '/images/map/hidden.svg' : '/images/map/visible.svg'"
                @click="toggleVisibilityForAllObjects()"
            />
        </header>
        <ul
            v-if="objects.length"
            class="map-items-list"
        >
            <li
                v-for="pin in sortedPins"
                :key="`pin-${pin.id}`"
                class="map-item"
            >
                <div>
                    <div>
                        <div class="map-item__gutter map-item__gutter--icon">
                            <img
                                :src="`/images/map/pin-${pin.type}.svg`"
                                :alt="`${pin.type}`"
                            />
                        </div>
                        <div class="map-item__identifier">
                            <p>{{ pin.name }}</p>
                            <span> {{ pin.latitude }}, {{ pin.longitude }} </span>
                        </div>

                        <map-item-controls
                            :isVisible="pin.isVisible()"
                            :mapItem="pin"
                            :clearMapObject="confirmClearMapObjectFor('pins')"
                            @set-visibility="pin.setVisible(!pin.isVisible())"
                            @locate-item="locateObject"
                        ></map-item-controls>
                    </div>
                </div>
            </li>

            <li
                v-for="shape in sortedShapes"
                :key="`shape-${shape.id}`"
                class="map-item"
            >
                <div>
                    <div>
                        <div class="map-item__gutter map-item__gutter--icon">
                            <img
                                :src="`/images/map/shape-${shape.type}.svg`"
                                :alt="`${shape.type}`"
                            />
                        </div>
                        <div class="map-item__identifier map-item__identifier--shapes">
                            <p>{{ shape.name }}</p>
                            <span
                                v-if="shape.type === 'circle'"
                                @click="shape.setCollapsed(!shape.isCollapsed())"
                            >
                                Center point and radius
                                <span :class="!shape.isCollapsed() ? 'icon-chevron-up' : 'icon-chevron-down'" />
                            </span>
                            <span
                                v-else
                                @click="shape.setCollapsed(!shape.isCollapsed())"
                            >
                                {{ shape.points.length }} points
                                <span :class="!shape.isCollapsed() ? 'icon-chevron-up' : 'icon-chevron-down'" />
                            </span>
                        </div>

                        <map-item-controls
                            :isVisible="shape.isVisible()"
                            :mapItem="shape"
                            :clearMapObject="confirmClearMapObjectFor('shapes')"
                            @set-visibility="shape.setVisible(!shape.isVisible())"
                            @locate-item="locateObject"
                        ></map-item-controls>
                    </div>
                    <ul
                        v-if="!shape.isCollapsed()"
                        class="map-item__dropdown-info"
                    >
                        <li
                            v-for="(point, id) in shape.points"
                            :key="id"
                            class="map-item"
                        >
                            {{ point.latitude }}, {{ point.longitude }}
                        </li>
                        <li v-if="shape.type === 'circle'">
                            {{ shape.points[0].radius | formatRadius }}
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
        <p
            v-else
            class="map-items-not-found"
        >
            No map objects available.
        </p>
    </section>
</template>

<script>
import * as _ from 'lodash'
import MapItemControls from './MapItemControls.vue'

export default {
    components: {
        MapItemControls,
    },

    filters: {
        formatRadius(radius) {
            return `${radius
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} meters`
        },
    },

    props: {
        pins: {
            type: Array,
            required: true,
        },

        shapes: {
            type: Array,
            required: true,
        },

        confirmClearMapObjectFor: {
            type: Function,
            required: true,
        },
    },

    computed: {
        objects() {
            return this.pins.concat(this.shapes)
        },

        sortedPins() {
            return _.sortBy(this.pins, [(pin) => pin.name.toLowerCase()])
        },

        sortedShapes() {
            return _.sortBy(this.shapes, [(shape) => shape.name.toLowerCase()])
        },

        areAllObjectsHidden() {
            const visible = (objects) => objects.isVisible()
            return !this.objects.some(visible)
        },
    },

    methods: {
        toggleVisibilityForAllObjects() {
            const visible = this.areAllObjectsHidden
            for (let i = 0; i < this.objects.length; i++) {
                this.objects[i].setVisible(visible)
            }
        },

        locateObject(object) {
            this.$eventBus.emit('centerOn', object)
        },
    },
}
</script>
